import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import { consigneeprofilereport } from '../../services/reportservice';
import { consigneeprofiledetailreport } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/appSlice';
import Pagination from '../../components/paginations';

const ConsigneeProfile = () => {
    const dispatch = useDispatch();
    const { accounts, loading, userInfo } = useSelector(state => state.appData);
    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

    const history = useHistory();
    const d = {
        StartDate: today,
        EndDate: today,
        account: [accounts[0]],
        contact: ''
    };
    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        consigneeName: ''
    };

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });


    const gridKeys = [
        {key: 'consigneeName', name: 'Consignee Name', searchBox: true, visible: true},
        {key: 'contact', name: 'Contact', searchBox: false, visible: true},
        {key: 'status', name: 'Status', searchBox: false, visible: true},
        {key: 'Show Detail', name: 'Action', searchBox: false, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        if (!valdiatePage('/consigneeprofile')) {
            history.push('/login');
        }
    }, []);

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const updateGrid = (index, key, val) => {
        const g = [...grid];
        g[index][key] = val;
        setGrid(g);
    }

    const onSearch = async () => {
        if (!data.StartDate) {
            alert('Enter From date');
            return;
        }
        if (!data.EndDate) {
            alert('Enter To date');
            return;
        }
        if (!data.account) {
            alert('Select Account');
            return;
        }

        if (Date.parse(data.StartDate) > Date.parse(data.EndDate)) {
            alert('Invalid Date Range');
            return;
        }

        dispatch(setLoading({ data: true }));

        var rs = await consigneeprofilereport(data);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                setGrid(rs.data);
                setOriginalGrid(rs.data);
            } else {
                alert('No Data Found');
                setGrid([]);
            }
        }
        else
            alert(rs.msg);
    }

    return userInfo &&
        <section className="section">
            <div className="section-header">
                <h1>Consignee Profile</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div className="row pb-2">
                    <div className="col">
                        <label>From</label>
                        <input type="date" className="form-control" value={data.StartDate} onChange={(e) => updateData('StartDate', e.target.value)} />
                    </div>
                    <div className="col">
                        <label>To</label>
                        <input type="date" className="form-control" value={data.EndDate} onChange={(e) => updateData('EndDate', e.target.value)} />
                    </div>
                    <div className="col">
                        <label>Account</label>
                        <select className="form-select" multiple value={data.account} onChange={(e) => {
                            let value = Array.from(e.target.selectedOptions, option => option.value);
                            updateData('account', value)
                        }}>
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>
                    <div className="col">
                        <label>Contact</label>
                        <input type="contact" className="form-control" value={data.contact} onChange={(e) => updateData('contact', e.target.value)} />
                    </div>
                    <div className="col">
                        <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem' }} onClick={onSearch}>
                            {loading ? <img src={Loader} height="30" /> : 'Search'}
                        </button>
                    </div>
                </div>

                {
                originalGrid && originalGrid.length > 0 &&
                <div className="row mt-3 pb-2">
                    <div className="col-12">
                        
                        <br />
                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <Fragment key={index}>
                                        <tr key={index}>
                                            <td>{(index + 1)+(page*pageLimit)}</td>
                                            <td>{x.consigneeName}</td>
                                            <td>{x.contact} </td>
                                            <td>{x.status}</td>
                                            <td><button className="btn btn-primary" onClick={() => {
                                                let objIndex = -1;
                                                for (let i = 0; i < grid.length; i++) {
                                                    if (grid[i]['contact'] === x.contact) {
                                                        objIndex = i;
                                                        break;
                                                    }
                                                }
                                                updateGrid(objIndex, 'showDetails', !x.showDetails)
                                            }}>Show Detail</button></td>
                                        </tr>
                                        {
                                            x.showDetails &&
                                            <tr>
                                                <td colSpan={5} className='dtablecell px-0'>
                                                    <div className='table-responsive new-table-mnp'>
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.No</th>
                                                                    <th>Consignee Name</th>
                                                                    <th>Contact</th>
                                                                    <th>Consignment Number</th>
                                                                    <th>Booking Date</th>
                                                                    <th>Runsheet Number</th>
                                                                    <th>Delivery Date</th>
                                                                    <th>Runsheet Date</th>
                                                                    <th>Status</th>
                                                                    <th>RiderCode</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    x.detail.map((item2, index2) =>
                                                                        <tr key={index2}>
                                                                            <td>{index2 + 1}</td>
                                                                            <td>{item2.consigneeName}</td>
                                                                            <td>{item2.contact}</td>
                                                                            <td>{item2.consignmentNumber}</td>
                                                                            <td>{item2.bookingDate}</td>
                                                                            <td>{item2.runsheetNumber}</td>
                                                                            <td>{item2.deliveryDate}</td>
                                                                            <td>{item2.runsheetDate}</td>
                                                                            <td>{item2.status}</td>
                                                                            <td>{item2.riderCode}</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </td>
                                            </tr>
                                        }
                                    </Fragment>
                                )
                            }
                        />
                    </div>
                </div>
            }
            </div>
        </section>
}

export default ConsigneeProfile;